export function formatUsd(cents: number | null | undefined): string {
  return (Number(cents || 0) / 100).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
  });
}

// SQLite's datetime('now') gives UTC as "YYYY-MM-DD HH:MM:SS" with no zone,
// which browsers would read as local time; treat zoneless values as UTC.
const ZONELESS = /^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}(:\d{2}(\.\d+)?)?$/;

/** Parses an API timestamp (SQLite UTC or ISO 8601) into a Date. */
export function parseTimestamp(value: string): Date {
  return new Date(ZONELESS.test(value) ? `${value.replace(' ', 'T')}Z` : value);
}

/** Date and time in the viewer's local timezone. */
export function formatDate(value: string | null | undefined): string {
  if (!value) return '—';
  const d = parseTimestamp(value);
  if (Number.isNaN(d.getTime())) return value;
  return d.toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    timeZoneName: 'short',
  });
}

/** Calendar date only, in the viewer's local timezone. */
export function formatDay(value: string | null | undefined): string {
  if (!value) return '—';
  const d = parseTimestamp(value);
  if (Number.isNaN(d.getTime())) return value;
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

export function shortId(uuid: string): string {
  return uuid.slice(0, 8).toUpperCase();
}
